var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 194 70",
    "aria-hidden": "true",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "58.65%",
    x2: "12.21%",
    y1: "50%",
    y2: "13.608%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00F076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0BE070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "25.147%",
    x2: "50%",
    y1: "40.585%",
    y2: "26.625%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#01C4F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "15.203%",
    x2: "50%",
    y1: "79.816%",
    y2: "59.404%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EB214E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF3A44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "0%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFD902"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFBD00"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "storesButton-background",
    width: 193.2,
    height: 70,
    fill: "#000",
    fillRule: "nonzero",
    rx: 11.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M64.986 21.34c0 1.174-.347 2.107-1.043 2.805-.791.828-1.82 1.243-3.086 1.243-1.212 0-2.244-.42-3.09-1.262-.85-.84-1.274-1.883-1.274-3.126 0-1.244.423-2.286 1.273-3.127.847-.84 1.879-1.26 3.091-1.26.6 0 1.178.117 1.724.351.547.235.985.547 1.314.938l-.739.74c-.556-.664-1.321-.998-2.299-.998-.884 0-1.649.311-2.294.933-.646.623-.968 1.43-.968 2.423 0 .993.322 1.8.968 2.422a3.19 3.19 0 0 0 2.294.933c.938 0 1.72-.313 2.347-.938.406-.408.64-.973.703-1.701h-3.05v-1.01h4.07c.04.22.059.43.059.634"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.7,
    d: "M64.986 21.34c0 1.174-.347 2.107-1.043 2.805-.791.828-1.82 1.243-3.086 1.243-1.212 0-2.244-.42-3.09-1.262-.85-.84-1.274-1.883-1.274-3.126 0-1.244.423-2.286 1.273-3.127.847-.84 1.879-1.26 3.091-1.26.6 0 1.178.117 1.724.351.547.235.985.547 1.314.938l-.739.74c-.556-.664-1.321-.998-2.299-.998-.884 0-1.649.311-2.294.933-.646.623-.968 1.43-.968 2.423 0 .993.322 1.8.968 2.422a3.19 3.19 0 0 0 2.294.933c.938 0 1.72-.313 2.347-.938.406-.408.64-.973.703-1.701h-3.05v-1.01h4.07c.04.22.059.43.059.634z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M71.439 17.832h-3.825v2.663h3.448v1.009h-3.448v2.663h3.825V25.2h-4.904v-8.4h4.904z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.7,
    d: "M71.439 17.832h-3.825v2.663h3.448v1.009h-3.448v2.663h3.825V25.2h-4.904v-8.4h4.904z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M75.99 25.2h-1.079v-7.368h-2.346V16.8h5.772v1.032H75.99z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.7,
    d: "M75.99 25.2h-1.079v-7.368h-2.346V16.8h5.772v1.032H75.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M82.513 25.2h1.08v-8.4h-1.08z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.7,
    d: "M82.513 25.2h1.08v-8.4h-1.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M88.38 25.2H87.3v-7.368h-2.346V16.8h5.772v1.032H88.38z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.7,
    d: "M88.38 25.2H87.3v-7.368h-2.346V16.8h5.772v1.032H88.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M96.291 23.411c.622.63 1.382.944 2.282.944.899 0 1.66-.314 2.282-.944.622-.63.934-1.434.934-2.41 0-.978-.312-1.783-.934-2.412-.622-.63-1.383-.945-2.282-.945-.9 0-1.66.315-2.282.945-.62.63-.932 1.434-.932 2.411 0 .977.312 1.781.932 2.411m5.362.703c-.826.85-1.852 1.274-3.08 1.274s-2.254-.424-3.079-1.274c-.826-.849-1.237-1.886-1.237-3.114s.411-2.266 1.237-3.115c.825-.848 1.851-1.272 3.079-1.272 1.22 0 2.244.425 3.074 1.278.83.852 1.244 1.888 1.244 3.11 0 1.227-.413 2.264-1.238 3.113"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.7,
    d: "M96.291 23.411c.622.63 1.382.944 2.282.944.899 0 1.66-.314 2.282-.944.622-.63.934-1.434.934-2.41 0-.978-.312-1.783-.934-2.412-.622-.63-1.383-.945-2.282-.945-.9 0-1.66.315-2.282.945-.62.63-.932 1.434-.932 2.411 0 .977.312 1.781.932 2.411zm5.362.703c-.826.85-1.852 1.274-3.08 1.274s-2.254-.424-3.079-1.274c-.826-.849-1.237-1.886-1.237-3.114s.411-2.266 1.237-3.115c.825-.848 1.851-1.272 3.079-1.272 1.22 0 2.244.425 3.074 1.278.83.852 1.244 1.888 1.244 3.11 0 1.227-.413 2.264-1.238 3.113z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M104.405 25.2v-8.4h1.313l4.083 6.534h.047l-.047-1.619V16.8h1.081v8.4h-1.127l-4.27-6.852h-.048l.048 1.62V25.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.7,
    d: "M104.405 25.2v-8.4h1.313l4.083 6.534h.047l-.047-1.619V16.8h1.081v8.4h-1.127l-4.27-6.852h-.048l.048 1.62V25.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M152.048 49.095h2.69V31.088h-2.69v18.007zm24.246-11.52l-3.086 7.807h-.092l-3.203-7.808h-2.9l4.805 10.912-2.74 6.07h2.807l7.402-16.982h-2.993zm-15.267 9.475c-.88 0-2.11-.441-2.11-1.53 0-1.389 1.532-1.923 2.854-1.923 1.182 0 1.74.256 2.459.602a3.262 3.262 0 0 1-3.203 2.85zm.326-9.87c-1.949 0-3.967.858-4.802 2.757l2.389.996c.51-.996 1.461-1.32 2.46-1.32 1.391 0 2.807.834 2.83 2.316v.186c-.488-.278-1.532-.695-2.808-.695-2.576 0-5.197 1.413-5.197 4.054 0 2.41 2.112 3.963 4.477 3.963 1.81 0 2.81-.811 3.434-1.762h.094v1.39h2.6V42.16c0-3.197-2.393-4.981-5.477-4.981zm-16.636 2.587h-3.829v-6.173h3.83c2.012 0 3.154 1.662 3.154 3.086 0 1.395-1.142 3.087-3.155 3.087zm-.07-8.68h-6.449v18.008h2.69v-6.822h3.76c2.983 0 5.916-2.158 5.916-5.593 0-3.436-2.933-5.594-5.916-5.594zm-35.171 15.966c-1.86 0-3.416-1.555-3.416-3.69 0-2.159 1.556-3.736 3.416-3.736 1.835 0 3.276 1.577 3.276 3.736 0 2.135-1.441 3.69-3.276 3.69zm3.09-8.47h-.092c-.605-.72-1.768-1.37-3.23-1.37-3.069 0-5.882 2.692-5.882 6.15 0 3.435 2.813 6.104 5.882 6.104 1.462 0 2.625-.65 3.23-1.393h.092v.881c0 2.346-1.255 3.597-3.276 3.597-1.65 0-2.673-1.182-3.092-2.18l-2.347.975c.674 1.623 2.463 3.62 5.439 3.62 3.16 0 5.834-1.857 5.834-6.383v-11h-2.558v.999zm4.417 10.512h2.695V31.088h-2.695v18.007zm6.67-5.94c-.07-2.369 1.836-3.574 3.206-3.574 1.07 0 1.977.534 2.28 1.3l-5.487 2.274zm8.366-2.043c-.512-1.368-2.068-3.9-5.252-3.9-3.16 0-5.788 2.484-5.788 6.128 0 3.435 2.604 6.127 6.09 6.127 2.811 0 4.438-1.717 5.113-2.716l-2.091-1.392c-.699 1.02-1.65 1.694-3.023 1.694-1.37 0-2.347-.627-2.973-1.857l8.203-3.388-.279-.696zm-65.36-2.018v2.599h6.227c-.185 1.462-.674 2.529-1.417 3.27-.907.907-2.325 1.905-4.81 1.905-3.837 0-6.834-3.087-6.834-6.916 0-3.828 2.997-6.917 6.833-6.917 2.069 0 3.58.813 4.694 1.858l1.837-1.833c-1.558-1.485-3.625-2.623-6.53-2.623-5.255 0-9.67 4.27-9.67 9.515 0 5.244 4.415 9.515 9.67 9.515 2.834 0 4.972-.93 6.645-2.67 1.72-1.716 2.255-4.13 2.255-6.08 0-.602-.046-1.16-.14-1.623h-8.76zm15.98 7.959c-1.858 0-3.462-1.532-3.462-3.713 0-2.205 1.604-3.713 3.462-3.713 1.86 0 3.464 1.508 3.464 3.713 0 2.181-1.604 3.713-3.464 3.713zm0-9.84c-3.393 0-6.158 2.577-6.158 6.127 0 3.528 2.765 6.127 6.158 6.127 3.395 0 6.16-2.599 6.16-6.127 0-3.55-2.765-6.127-6.16-6.127zm13.437 9.84c-1.86 0-3.464-1.532-3.464-3.713 0-2.205 1.604-3.713 3.464-3.713 1.86 0 3.462 1.508 3.462 3.713 0 2.181-1.603 3.713-3.462 3.713zm0-9.84c-3.393 0-6.159 2.577-6.159 6.127 0 3.528 2.766 6.127 6.159 6.127s6.158-2.599 6.158-6.127c0-3.55-2.765-6.127-6.158-6.127z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M24.71 12.722L3.358.539C2.449.022 1.414.222.735.84l17.899 17.937 6.076-6.055z",
    transform: "translate(13.086 16.752)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M.735.841C.294 1.241 0 1.815 0 2.495v32.69c0 .619.245 1.149.62 1.543l18.014-17.952L.735.841z",
    transform: "translate(13.086 16.752)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M.62 36.728c.673.706 1.78.962 2.741.412l21.382-12.243-6.109-6.121L.62 36.728z",
    transform: "translate(13.086 16.752)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M31.956 16.855l-7.247-4.133-6.074 6.053 6.107 6.122 7.217-4.132c1.51-.865 1.507-3.047-.003-3.91",
    transform: "translate(13.086 16.752)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.99a212543864ef451c9e5d12ad0af1ed.svg";
export { ForwardRef as ReactComponent };